module.exports = __webpack_public_path__ + "./docs/img/icon-references.b7f5e031842af908424cbc530dd5242a.svg";